module.exports = __webpack_public_path__ + "static/media/pray.7f858463.svg";